export default "__VITE_ASSET__C2_QiA80__";